import React, { useState } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";

import ExpandedContent from "../../../components/ExpandedContent";
import BalanceDetails from "../../../components/BalanceDetails";
import { PageTitle } from "../../../../../components/page-title/PageTitle";
import User from "../../../../../models/User";

interface WalletOverviewProps {
  user: User;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {},
    subMain: {
      padding: "32px 32px",
    },
    actions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    actionItem: {
      marginLeft: 20,
    },
  }),
  { name: "personal-wallet-overview-tab-styles" }
);

export default function WalletOverview(props: WalletOverviewProps) {
  const classes = useStyles(props);
  const intl = useIntl();
  // State
  const [user, setUser] = useState(props.user);

  return (
    <>
      <PageTitle
        withAppTitle={false}
        title={`${intl.formatMessage({
          id: "sharedScreen.admin",
        })} - ${intl.formatMessage({
          id: "sharedScreen.personalAccountWallet",
        })}`}
      />
      <Box component="div" className={classes.root}>
        <Box component="div">
          <Typography variant="h4" component="h4" className={classes.subMain}>
            <FormattedMessage id="sharedScreen.wallet" />
          </Typography>
          <ExpandedContent
            title={intl.formatMessage({ id: "sharedScreen.balances" })}
          >
            <BalanceDetails accounts={user.accounts} />
          </ExpandedContent>
        </Box>
      </Box>
    </>
  );
}
